import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ModalDialogComponent } from '../modal-dialog/modal-dialog.component';
import { MatIcon } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FileUploadComponent } from '../file-upload/file-upload.component';
import { MultiUploadModalData } from '../interfaces/modal.data';
import { FormControl, Validators } from '@angular/forms';
import { catchError, debounceTime, distinctUntilChanged, filter, of, switchMap } from 'rxjs';
import { InstrumentRunService } from '../../services/instrument-run/instrument-run.service';
import { InputComponent } from '../input/input.component';
import { SvTestPannelService } from '../../services/sv-test-pannel/sv-test-panel.service';
import { ReactiveFormsModule } from '@angular/forms';
import { noWhitespaceValidator } from '../validators/no-whitespace.validator';
import { UploadType } from '../../services/upload/upload-type';

@Component({
  selector: 'app-multi-file-upload-modal',
  standalone: true,
  imports: [
    MatDialogModule,
    CommonModule,
    MatButtonModule,
    MatProgressBarModule,
    MatIcon,
    DragDropModule,
    FileUploadComponent,
    InputComponent,
    ReactiveFormsModule,
  ],
  templateUrl: './multi-file-upload-modal.component.html',
  styleUrl: './multi-file-upload-modal.component.css',
})
export class MultiFileUploadModalComponent {
  btnStyleFilledSmallForPrimaryBtn = 'btn-filled-small';
  btnMatFlat: string = 'mat-flat-button';
  arialLabel: string = 'Done';
  isDisabled = false;

  // file upload container
  @ViewChild('dropzoneElement', { static: true }) dropzoneElement!: ElementRef;
  selectFileBtnText = $localize`Select File`;
  btnMatStroked = 'mat-stroked-button';
  btnStyleStroked = 'btn-stroked';
  downloadIcon = 'cloud_upload';

  nameControl = new FormControl('', [Validators.required, Validators.maxLength(256), noWhitespaceValidator()]);
  descriptionControl = new FormControl('', [Validators.maxLength(1024), noWhitespaceValidator()]);

  nameExists: boolean | null = null;
  invalidIfileName = false;

  constructor(
    private instrumentRunService: InstrumentRunService,
    private svPanelTetsService: SvTestPannelService,
    public dialogRef: MatDialogRef<ModalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MultiUploadModalData
  ) {}

  ngOnInit(): void {
    let serviceInstance;

    if (this.data.uploadConfig.featureType === UploadType.InstrumentRun) {
      serviceInstance = this.instrumentRunService;
    } else {
      serviceInstance = this.svPanelTetsService;
    }

    this.nameControl.valueChanges
      .pipe(
        debounceTime(500), // wait before firing API
        distinctUntilChanged(),
        switchMap((name) => serviceInstance.isFileExist(name!).pipe(catchError(() => of({ exists: false }))))
      )
      .subscribe((res) => {
        if (this.nameControl.value !== '') {
          this.nameExists = !res.data.is_unique;
          this.invalidIfileName = false;
        } else this.invalidIfileName = true;
      });
  }

  // Handle upload start
  onUploadStarted(fileIds: string[]) {
    this.onPrimaryAction();
  }

  onFileAdded(status: boolean) {
    this.onPrimaryAction();
  }

  onCompleted($event: boolean) {
    // Might be useful in future to perform some action when upload is completed
  }

  // Handle upload completion
  onAllUploadsComplete() {
    // Might be useful in future to perform some action when all uploads are completed
    // Navigate to next page or show success message
  }
  onPrimaryAction(): void {
    this.dialogRef.close(true);
  }

  onSecondaryAction(): void {
    this.dialogRef.close(false);
  }
  ngOnDestroy(): void {}
}
